<template>
  <div class="layout">
    <a-layout>
      <layout-header />
      <a-layout-content>
        <div class="content-container">
          <router-view></router-view>
        </div>
      </a-layout-content>
      <layout-footer />
      <div class="footer-image"></div>
    </a-layout>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import LayoutHeader from './components/layout-header'
import LayoutFooter from './components/layout-footer'

export default {
  components: { LayoutHeader, LayoutFooter },
  created() {
    this.getPrivilege()
  },
  methods: {
    ...mapActions({
      getPrivilege: 'user/getPrivilege'
    })
  }
}
</script>

<style lang="less" scoped>
.layout {
  min-width: @safe-width;

  .content-container {
    position: relative;
    width: @safe-width;
    min-height: calc(100vh - 200px);
    margin: auto;
    padding: @spacing-4x 0;
  }
}
</style>
